module.exports = __webpack_public_path__ + "media/customizations/mygcplife/logo-bc63b6fce9d37a9fa2e84671573a0c2b.png";